const Types = {
  DELETE_ACCOUNT_SUCCESS: "DELETE_ACCOUNT_SUCCESS",
  AUTH_LOADING: "AUTH_LOADING",
};

export default Types;
